<template>
<div>

    <!-- generated code preview -->
    <div v-if="isNewFile" class="w-full mt-4 mb-2 p-3 rounded border" :class="allFieldsFilled ? 'border-blue bg-blue-lightest' : 'border-grey-light bg-grey-lightest'">
      <div class="text-xs text-grey mb-1">{{ $t("code") }}</div>
      <div v-if="codedName" class="flex flex-wrap items-center">
        <span v-for="(part, idx) in codedNameParts" :key="'cp_'+idx" class="inline-flex items-center">
          <span class="font-mono font-bold text-sm px-1 rounded"
            :class="part.fixed ? 'text-grey-dark' : 'text-blue-dark bg-white border border-blue-lighter'">
            {{ part.value }}
          </span>
          <span v-if="idx < codedNameParts.length - 1" class="text-grey mx-px font-bold">-</span>
        </span>
      </div>
      <div v-else class="text-xs text-grey-dark italic">Completa los campos para generar el código</div>
    </div>

    <!-- nuevo fichero, mostrar todos los select para codificar nombre -->
    <div v-if="isNewFile">
      <!-- nombre descriptivo -->
      <div class="flex flex-col w-full mb-4">
        <b-field
        :label="$t('descriptive_name') + ' (' + $t('optional') + ')'"
        class="mb-4">
          <input
            v-model="desc_name"
            type="text"
            class="w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring focus:ring-blue-200 p-2"
          />
        </b-field>
      </div>

      <!-- Año y selector de codificador -->
      <div class="flex gap-4 mb-4">
        <b-field :label="$t('year')">
          <b-select v-model="dataOptions.tyear" :placeholder="$t('select')" expanded>
            <option v-for="i in tyearValues" :value="i.value" :key="'tyear_'+i.value">
                {{ i.name }}
            </option>
          </b-select>
        </b-field>

        <b-field label="Documentos">
          <b-select v-model="codificadorType" :placeholder="$t('select')" expanded>
            <option value="planos">Codificador Planos</option>
            <option value="resto">Resto Codificador</option>
          </b-select>
        </b-field>
      </div>

      <!-- ==================== CODIFICADOR 1 (Planos) ==================== -->
      <div v-if="codificadorType === 'planos'">
        <div class="flex gap-4 mb-4">
          <b-field label="Disciplina">
            <b-select v-model="dataOptions.c1Disciplina" :placeholder="$t('select')" expanded>
              <option
                v-for="item in c1Disciplinas"
                :key="'c1d_'+item.code"
                :value="item.code"
              >
                {{ item.code }} - {{ item.description }}
              </option>
            </b-select>
          </b-field>

          <b-field label="Tipo de documento">
            <b-select v-model="dataOptions.c1TipoDocumento" :placeholder="$t('select')" expanded>
              <option
                v-for="item in c1TiposDocumento"
                :key="'c1td_'+item.code"
                :value="item.code"
              >
                {{ item.code }} - {{ item.description }}
              </option>
            </b-select>
          </b-field>
        </div>

        <div class="flex gap-4 mb-4">
          <b-field label="Nº de orden">
            <b-input
              type="number"
              min="1"
              max="999"
              v-model="dataOptions.number"
              placeholder="001"
              class="w-full"
            ></b-input>
          </b-field>

          <b-field :label="$t('description')">
            <input
              v-model="dataOptions.descripcion"
              type="text"
              :placeholder="$t('description')"
              class="w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring focus:ring-blue-200 p-2"
            />
          </b-field>
          
          <b-field label="Revisión">
            <b-select v-model="dataOptions.revisionLetter" :placeholder="$t('select')" expanded>
              <option v-for="letter in abecedary" :value="letter" :key="'rev_'+letter">
                R{{ letter }}
              </option>
            </b-select>
          </b-field>
        </div>

      </div>

      <!-- ==================== CODIFICADOR 2 (Resto) ==================== -->
      <div v-if="codificadorType === 'resto'">
        <div class="flex gap-4 mb-4">
          <b-field label="Creador">
            <b-select v-model="dataOptions.c2Creador" :placeholder="$t('select')" expanded>
              <option
                v-for="item in c2Creadores"
                :key="'c2cr_'+item.code"
                :value="item.code"
              >
                {{ item.code }} - {{ item.description }}
              </option>
            </b-select>
          </b-field>

          <b-field label="Tipo de documento">
            <b-select v-model="dataOptions.c2TipoDocumento" :placeholder="$t('select')" expanded>
              <option
                v-for="item in c2TiposDocumento"
                :key="'c2td_'+item.code"
                :value="item.code"
              >
                {{ item.code }} - {{ item.description }}
              </option>
            </b-select>
          </b-field>

          <b-field label="Disciplina">
            <b-select v-model="dataOptions.c2Disciplina" :placeholder="$t('select')" expanded>
              <option
                v-for="item in c2Disciplinas"
                :key="'c2di_'+item.code"
                :value="item.code"
              >
                {{ item.code }} - {{ item.description }}
              </option>
            </b-select>
          </b-field>
        </div>

        <div class="flex gap-4 mb-4">
          <b-field label="Nº de orden">
            <b-input
              type="number"
              min="1"
              max="999"
              v-model="dataOptions.number"
              placeholder="001"
              class="w-full"
            ></b-input>
          </b-field>

          <b-field :label="$t('description')">
            <input
              v-model="dataOptions.descripcion"
              type="text"
              :placeholder="$t('description')"
              class="w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring focus:ring-blue-200 p-2"
            />
          </b-field>

          <b-field label="Revisión">
            <b-select v-model="dataOptions.revisionLetter" :placeholder="$t('select')" expanded>
              <option v-for="letter in abecedary" :value="letter" :key="'rev2_'+letter">
                R{{ letter }}
              </option>
            </b-select>
          </b-field>
        </div>
        
      </div>

      <!-- boton para generar nombre -->
      <div class="flex items-center gap-2">
        <div class="cursor-default tag" type="button"
            :class="allFieldsFilled ? 'is-info' : 'is-light'"
            @click="allFieldsFilled ? generateName() : null">
            {{$t('generate_filename')}} <b-icon pack="fas" icon="file-alt" />
        </div>
        <span v-if="!allFieldsFilled" class="text-xs text-red">Todos los campos son obligatorios</span>
      </div>

    </div>

    <!-- nueva version. Mostrar solo el select de revision si es detectado en el nombre -->
    <!-- ya no hace falta. aumentamos version automaticamente si se encuentra el patron -R{letra} en el nombre del documento original -->
    <!-- <div v-if="!isNewFile && hasVersionNumber()" class="flex flex-row w-full pb-3 mt-4">
        Revisión:
        <div class="flex flex-col p-2 font-bold">R</div>
        <b-select v-model="version.letter" placeholder="Revisión" class="flex flex-col">
            <option v-for="letter in abecedary" :value="letter" :key="'tvr_'+letter">
                {{ letter }}
            </option>
        </b-select>
    </div> -->



</div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from 'moment'
// Catálogos centralizados en rejas-config.js para compartirlos con los filtros
import {
  c1Disciplinas, c1TiposDocumento,
  c2Creadores, c2TiposDocumento, c2Disciplinas,
  abecedary, getYearValues,
} from './rejas-config'

export default {
  name: "codification-rejas",

  components: {
  },


  props: {
    form: {type: Object, required: false},
    isNewFile: {type: Boolean, required: false, default: true},
    originalDocument: {type: Object, required: false, default: null},
  },


  data: () => ({
    tyearValues: [],
    abecedary,
    desc_name: '',
    regex: /-R[A-Z](?!\w)/,

    codificadorType: 'planos', // 'planos' (codificador 1) o 'resto' (codificador 2)

    dataOptions: {
      tyear: moment().format('YY'),
      // Codificador 1 fields
      c1Disciplina: '',
      c1TipoDocumento: '',
      // Codificador 2 fields
      c2Creador: '',
      c2TipoDocumento: '',
      c2Disciplina: '',
      // Common fields
      number: 1,
      descripcion: '',
      revisionLetter: 'A',
    },

    codedName: '',

    // version para subir nueva version de fichero existente
    version: { letter: 'A' },

    c1Disciplinas,
    c1TiposDocumento,
    c2Creadores,
    c2TiposDocumento,
    c2Disciplinas,

  }),


  created() {

    this.tyearValues = this.getYearValues()

    // al subir version: si detectamos patron de versionado -R{letra} en el nombre del documento original,
    // generamos automaticamente el nombre con la siguiente letra y emitimos
    if (!this.isNewFile && this.originalDocument && this.hasVersionNumber()) {
        const nextVersionName = this.getNextVersionName(this.originalDocument.name)
        // quitamos extension para custom_name (el padre la añade a partir del fichero subido)
        const nameWithoutExt = nextVersionName.replace(/\.[^.]+$/, '')
        this.$nextTick(() => {
            this.$emit('generatedCodename', {
                desc_name: this.originalDocument.desc_name || '',
                custom_name: nameWithoutExt,
                coded_name: this.originalDocument.coded_name || 0,
            })
        })
    }
  },


  computed: {

    ...mapGetters({
        project: 'app/project',
    }),

    codedNameParts() {
      if (!this.codedName) return []
      return this.codedName.split('-').map(part => ({
        value: part,
        fixed: part === 'DREJ',
      }))
    },

    allFieldsFilled() {
      const { tyear, number, descripcion, revisionLetter } = this.dataOptions

      // campos comunes obligatorios
      if (!tyear || !number || !descripcion || !revisionLetter) return false

      if (this.codificadorType === 'planos') {
        return !!(this.dataOptions.c1Disciplina && this.dataOptions.c1TipoDocumento)
      } else {
        return !!(this.dataOptions.c2Creador && this.dataOptions.c2TipoDocumento && this.dataOptions.c2Disciplina)
      }
    },

  },

  watch: {
    dataOptions: {
      handler() {
        this.generateCode()
      },
      deep: true,
      immediate: true
    },
    codificadorType() {
      this.generateCode()
    }
  },

  methods: {

    getYearValues() {
        return getYearValues(moment)
    },

    generateCode() {
      const { tyear, number, descripcion, revisionLetter } = this.dataOptions
      const numberStr = number > 0 ? number.toString().padStart(3, '0') : ''
      const revision = revisionLetter ? 'R' + revisionLetter : ''

      let parts = []

      if (this.codificadorType === 'planos') {
        // Codificador 1: {year}-DREJ-{disciplina}D{tipo_doc}-{000}-{descripcion}-R{letter}
        const { c1Disciplina, c1TipoDocumento } = this.dataOptions
        const middleBlock = (c1Disciplina && c1TipoDocumento)
          ? c1Disciplina + 'D' + c1TipoDocumento
          : ''

        parts = [
          tyear,
          'DREJ',
          middleBlock,
          numberStr,
          descripcion,
          revision
        ]
      } else {
        // Codificador 2: {year}-DREJ-{creador}-{tipo_doc}-{disciplina}-{000}-{descripcion}-R{letter}
        const { c2Creador, c2TipoDocumento, c2Disciplina } = this.dataOptions

        parts = [
          tyear,
          'DREJ',
          c2Creador,
          c2TipoDocumento,
          c2Disciplina,
          numberStr,
          descripcion,
          revision
        ]
      }

      this.codedName = parts.filter(Boolean).join('-')
    },


    // aplica el codigo de nombre generado al campo custom_name
    async generateName() {

        this.$emit('generatedCodename', {
            desc_name: this.desc_name || '',
            custom_name: this.codedName,
            coded_name: this.codedName ? 1 : 0,
        })

    },


    // detecta si el fichero al que vamos a subir version tenia la revision en su nombre (-RA, -RB, etc)
    hasVersionNumber() {
        return this.originalDocument && this.regex.test(this.originalDocument.name);
    },

    // genera el nombre de la siguiente version incrementando la letra de revision (-RA -> -RB, -RB -> -RC...)
    getNextVersionName(fileName) {
        const regex = /-R([A-Z])(?=\.[^.]+$|$)/
        const match = fileName.match(regex)
        if (!match) return fileName
        const currentLetter = match[1]
        if (currentLetter === 'Z') return fileName // ya es la ultima letra, no se puede incrementar
        const nextLetter = String.fromCharCode(currentLetter.charCodeAt(0) + 1)
        return fileName.replace(regex, '-R' + nextLetter)
    }


  }
}
</script>
